/**
 * Record that a cited or shown nook was opened (block 17, PRD §11's
 * answer-quality proxy). Fire-and-forget: nothing renders from it.
 */
import { useMutation } from "@tanstack/react-query";
import { getNookClient } from "../client.js";
export function useRecordAskOpen() {
    return useMutation({
        mutationFn: ({ messageId, nookId }) => getNookClient().recordAskOpen(messageId, nookId),
    });
}
//# sourceMappingURL=use-record-ask-open.js.map